import { Stack, styled } from '@mui/material';

export const ScrollableStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(),
  overflowY: 'auto',
  '&::-webkit-scrollbar': { width: 10 },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#00000033'
  },
  '&::-webkit-scrollbar-track:hover': {
    backgroundColor: '#0000002A'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#00000077',
    borderRadius: theme.shape.borderRadius
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#00000055'
  },
  scrollbarColor: '#00000077 #00000033',
  scrollbarWidth: 'thin'
}));
